import { NewProviderNote } from './provider-note.types';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProviderNoteService {
	private notesUrl = (providerId: number) => `api/providers/${providerId}/notes`;
	private noteUrl = (providerId: number, noteId: number) => `api/providers/${providerId}/notes/${noteId}`;

	constructor(private http: HttpClient) { }

	addNote(providerId: number, newNote: NewProviderNote): Promise<number> {
		return this.http.post<number>(this.notesUrl(providerId), newNote).toPromise();
	}

	deleteNote(providerId: number, noteId: number): Promise<void> {
		return this.http.delete<void>(this.noteUrl(providerId, noteId)).toPromise();
	}
}
